import { extractAccounts } from '../queryTransforms';

import { type AccountsListParams, useAccounts } from './useAccounts';

export function useAccountsList(params: AccountsListParams = {}, options?: { enabled?: boolean }) {
  const q = useAccounts(params, options);
  const accounts = typeof window !== 'undefined' && q.data ? extractAccounts(q.data) : [];
  return { ...q, accounts } as const;
}
